import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  frontendBuildUrlWithUtm,
  UTM_CAMPAIGNS,
} from "@bezoned/shared/utils/utm-links.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

export const DESKTOP_APP_URL = frontendBuildUrlWithUtm(
  "https://bezoned.com/bezoned-hud-installation",
  UTM_CAMPAIGNS.OFFICE_APP.INSTALL_SIDEBAR
);

interface DesktopAppDialogProps {
  open: boolean;
  onDismiss: () => void;
  onViewMore: () => void;
}

export const DesktopAppDialog = ({
  open,
  onDismiss,
  onViewMore,
}: DesktopAppDialogProps) => {
  const handleOpenChange33 = useStableCallback((_event, data) => {
    if (!data.open) {
      onDismiss();
    }
  });

  return (
    <Dialog onOpenChange={handleOpenChange33} open={open}>
      <DialogSurface>
        <DialogBody className="flex flex-col gap-6">
          <DialogTitle>Sidebar App</DialogTitle>
          <DialogContent>
            <div className="flex flex-col gap-4">
              <img
                alt="Preview of the Table Sidebar app"
                className="w-full rounded-lg object-cover"
                height={720}
                src="/images/table-sidebar.jpeg"
                width={1280}
              />
              <p className="text-base">
                Having the BeZoned office window visible can be difficult when
                screen space is limited. That’s why you can use the Sidebar
                alongside your screen.
              </p>
              <p className="text-base">
                The Sidebar <strong>stays on top</strong> of other applications,
                letting you see who’s sitting around the table and interact just
                like in the BeZoned office window. It also extends the
                push-to-talk functionality, so you can toggle your microphone on
                and off even when the BeZoned office window is not in focus.
              </p>
              <p className="text-base">
                To use the Sidebar, you need to install it on your computer.
                Click the Install now button below and follow the instructions.
              </p>
            </div>
          </DialogContent>
          <DialogActions className="mt-2 flex w-full justify-end gap-2">
            <Button appearance="secondary" onClick={onDismiss}>
              Maybe later
            </Button>
            <Button
              appearance="primary"
              as="a"
              href={DESKTOP_APP_URL}
              onClick={onViewMore}
              rel="noopener noreferrer"
              target="_blank"
            >
              Install now
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
